import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomHeaderComponent } from './components/custom-header/custom-header.component';
import { CustomFooterComponent } from './components/custom-footer/custom-footer.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { PrimengModule } from '../primeng/primeng.module';
import { CustomInputComponent } from './components/custom-input/custom-input.component';
import { CustomBaseComponent } from './components/custom-base/custom-base.component';
import { CustomButtonComponent } from './components/custom-button/custom-button.component';
import { CustomDividerComponent } from './components/custom-divider/custom-divider.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMenuBarComponent } from './components/custom-menu-bar/custom-menu-bar.component';
import { CustomIconButtonComponent } from './components/custom-icon-button/custom-icon-button.component';
import { CustomColumnTableComponent } from './components/custom-column-table/custom-column-table.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { CustomEditorComponent } from './components/custom-editor/custom-editor.component';
import { CustomCalendarComponent } from './components/custom-calendar/custom-calendar.component';
import { CustomErrorToastComponent } from './components/custom-error-toast/custom-error-toast.component';
import { CustomListProductComponent } from '../site/product-catalog/components/custom-list-product/custom-list-product.component';
import { CustomProductCardComponent } from '../site/product-catalog/components/custom-product-card/custom-product-card.component';
import { CustomCardEventsNewsComponent } from './components/custom-card-events-news/custom-card-events-news.component';
import { DialogModule } from 'primeng/dialog';
import { ShoppingCarModalComponent } from '../site/shopping-car/components/shopping-car-modal/shopping-car-modal.component';
import { WishList } from '../utils/functions/wishList';
import { MakeOrderModalComponent } from '../site/shopping-car/components/make-order-modal/make-order-modal.component';
import { CustomNoStockComponent } from './components/custom-no-stock/custom-no-stock.component';
import { CustomInputNumberControlComponent } from './components/custom-input-number-control/custom-input-number-control.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { CustomChargingComponent } from './components/custom-charging/custom-charging.component';
import { MessagesModule } from 'primeng/messages';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from '../utils/error.interceptor';
import { CustomOrderListComponent } from '../site/orders/components/custom-order-list/custom-order-list.component';
import { CustomItemOrderListComponent } from '../site/orders/components/custom-item-order-list/custom-item-order-list.component';
import { CustomInputFileComponent } from './components/custom-input-file/custom-input-file.component';
import { CustomLabelComponent } from './components/custom-label/custom-label.component';
import { CustomInputSimpleComponent } from './components/custom-input-simple/custom-input-simple.component';
import { CustomRadioButtonComponent } from './components/custom-radio-button/custom-radio-button.component';
import { CustomFullSizeEventsNewsComponent } from './components/custom-full-size-events-news/custom-full-size-events-news';
import { CustomInputAccesorComponent } from './components/custom-input-accesor/custom-input-accesor.component';
import { CustomRadioButtonAccesorComponent } from './components/custom-radio-button-accesor/custom-radio-button-accesor.component';
import { CustomEditorAccesorComponent } from './components/custom-editor-accesor/custom-editor-accesor.component';
import { CustomNoContentComponent } from './components/custom-no-content/custom-no-content.component';
import { CustomDropdownAccesorComponent } from './components/custom-dropdown-accesor/custom-dropdown-accesor.component';
import { CustomTextareaAccesorComponent } from './components/custom-textarea-accesor/custom-textarea-accesor.component';
import { CustomCalendarAccesorComponent } from './components/custom-calendar-accesor/custom-calendar-accesor.component';
import { CustomBreadcrumbComponentComponent } from './components/custom-breadcrumb-component/custom-breadcrumb-component.component';
import { CustomMultiSelectAccesorComponent } from './components/custom-multi-select-accesor/custom-multi-select-accesor.component';
import { CustomWishListComponent } from '../site/shopping-car/components/custom-wish-list/custom-wish-list.component';
import { CustomItemWishListComponent } from '../site/shopping-car/components/custom-item-wish-list/custom-item-wish-list.component';
import { DeleteItemWishListModalComponent } from '../site/shopping-car/components/delete-item-wish-list-modal/delete-item-wish-list-modal.component';
import { CustomItemCardImageWishListComponent } from '../site/shopping-car/components/custom-item-card-image-wish-list/custom-item-card-image-wish-list.component';
import { CustomItemCardBodyWishListComponent } from '../site/shopping-car/components/custom-item-card-body-wish-list/custom-item-card-body-wish-list.component';
import { ConfirmDirectionModalComponent } from '../site/shopping-car/components/confirm-direction-modal.component/confirm-direction-modal.component';
import { CustomCheckboxAccesorComponent } from './components/custom-checkbox-accesor/custom-checkbox-accesor.component';

@NgModule({
  declarations: [
    CustomHeaderComponent,
    CustomFooterComponent,
    ErrorPageComponent,
    CustomInputComponent,
    CustomBaseComponent,
    CustomButtonComponent,
    CustomDividerComponent,
    CustomMenuBarComponent,
    CustomIconButtonComponent,
    CustomColumnTableComponent,
    CustomDropdownComponent,
    CustomEditorComponent,
    CustomCalendarComponent,
    CustomErrorToastComponent,
    CustomListProductComponent,
    CustomProductCardComponent,
    CustomCardEventsNewsComponent,
    ShoppingCarModalComponent,
    MakeOrderModalComponent,
    CustomInputNumberControlComponent,
    CustomChargingComponent,
    CustomOrderListComponent,
    CustomItemOrderListComponent,
    CustomNoStockComponent,
    CustomInputFileComponent,
    CustomLabelComponent,
    CustomInputFileComponent,
    CustomInputSimpleComponent,
    CustomRadioButtonComponent,
    CustomFullSizeEventsNewsComponent,
    CustomInputAccesorComponent,
    CustomRadioButtonAccesorComponent,
    CustomEditorAccesorComponent,
    CustomNoContentComponent,
    CustomDropdownAccesorComponent,
    CustomTextareaAccesorComponent,
    CustomCalendarAccesorComponent,
    CustomBreadcrumbComponentComponent,
    CustomMultiSelectAccesorComponent,
    CustomWishListComponent,
    CustomItemWishListComponent,
    DeleteItemWishListModalComponent,
    CustomItemCardImageWishListComponent,
    CustomItemCardBodyWishListComponent,
    ConfirmDirectionModalComponent,
    CustomCheckboxAccesorComponent
  ],
  exports: [
    CustomHeaderComponent,
    CustomFooterComponent,
    CustomInputComponent,
    CustomBaseComponent,
    CustomButtonComponent,
    CustomDividerComponent,
    CustomMenuBarComponent,
    CustomIconButtonComponent,
    CustomColumnTableComponent,
    CustomDropdownComponent,
    CustomEditorComponent,
    CustomCalendarComponent,
    CustomErrorToastComponent,
    CustomListProductComponent,
    CustomCardEventsNewsComponent,
    DialogModule,
    MakeOrderModalComponent,
    ShoppingCarModalComponent,
    CustomInputNumberControlComponent,
    InputNumberModule,
    CustomChargingComponent,
    MessagesModule,
    CustomOrderListComponent,
    CustomItemOrderListComponent,
    CustomInputFileComponent,
    CustomInputSimpleComponent,
    CustomRadioButtonComponent,
    CustomNoStockComponent,
    CustomProductCardComponent,
    CustomFullSizeEventsNewsComponent,
    CustomInputAccesorComponent,
    CustomLabelComponent,
    CustomRadioButtonAccesorComponent,
    CustomEditorAccesorComponent,
    CustomNoContentComponent,
    CustomDropdownAccesorComponent,
    CustomTextareaAccesorComponent,
    CustomCalendarAccesorComponent,
    CustomBreadcrumbComponentComponent,
    CustomMultiSelectAccesorComponent,
    CustomWishListComponent,
    CustomItemWishListComponent,
    DeleteItemWishListModalComponent,
    CustomItemWishListComponent,
    CustomItemCardImageWishListComponent,
    CustomItemCardBodyWishListComponent,
    ConfirmDirectionModalComponent,
    CustomCheckboxAccesorComponent
  ],
  imports: [CommonModule, PrimengModule, FormsModule, InputNumberModule, MessagesModule, ReactiveFormsModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    WishList,
    InputNumberModule
  ],
})
export class SharedModule {}
